import styled, {css} from 'styled-components'

import {media, visibility, OntarioRow, OntarioColumn} from '../../theme'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const HeaderContainer = styled.div`
  z-index: 5;
`

export const StyledHeader = styled.header`
  position: relative;
  background-color: var(--ontario-colour-greyscale-black);
  color: var(--ontario-colour-greyscale-white);
  display: flex;
  align-items: center;
  height: 5.75rem;
  z-index: 5;

  @media ${media.medium} {
    z-index: 1;
  }
`

export const HeaderRow = styled(OntarioRow)`
  flex-direction: row;
  align-items: center;

  ${props =>
    props.searchOpen &&
    css`
      justify-content: flex-end;
    `}

  form {
    width: 50%;
    margin-left: var(--ontario-spacing-0);
    display: flex;
  }

  // Needed to override NPM package themes for specific Search Results Page fixes.
  #ontario-search-autosuggest {
    display: none;

    @media (min-width: 73em) {
      padding-left: 0rem;
      padding-right: 0rem;
    }

    ${props =>
      props.searchOpen &&
      css`
        display: flex;
      `};

    @media ${media.medium} {
      display: block;
    }
    form {
      width: 100%;
    }
    button {
      @media (max-width: 40em) {
        top: 6px;
      }
      right: 0rem;
      top: 4px;
    }

    #search-form-container {
      display: block;

      // Search Reset button for our repo has different CSS needs.
      div[type='reset'] > div {
        z-index: 1;
        position: absolute;
        display: flex;
        align-items: center;
        top: 15px;
        right: 63px;
        height: 28px;
        width: 28px;
        color: #000;
        margin: 0;
        padding: 0.1rem;
        outline: none;
        border: none;
        cursor: pointer;

        @media (max-width: 72em) {
          top: 15px;
        }

        @media (max-width: 40em) {
          top: 17px;
        }

        ${props =>
          props.searchOpen &&
          css`
            right: 64px;
          `}

        &:focus {
          box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
        }
      }
    }
  }

  ${props =>
    props.searchOpen &&
    css`
      form {
        display: flex;
        width: 83.333%;
        padding-left: 1rem;
        padding-right: 1rem;
        box-sizing: border-box;

        @media ${media.xsmall} {
          width: 83.333333%;
          margin-left: 0;
          padding-left: 0rem;
          padding-right: 0rem;
        }
        @media ${media.small} {
          width: 50%;
          // margin-left: 25%;
          padding-left: 0rem;
          padding-right: 0rem;
        }

        @media ${media.medium} {
          width: 56%;
          margin-left: 0%;
          padding-left: 0rem;
          padding-right: 0rem;
        }
      }
    `}
`

export const LogoContainer = styled(OntarioColumn)`
  height: 46px;
  width: 16.6%;
  ${props =>
    props.searchOpen &&
    css`
      display: none;
    `}

  @media ${media.medium} {
    width: 25%;
    display: flex;
  }

  a {
    display: inline-block;
    height: 100%;

    &:focus {
      box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
    }
  }
`

export const HeaderRightSideContainer = styled.div`
  width: 83.3%;
  padding: var(--ontario-spacing-0) var(--ontario-spacing-4);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${props =>
    props.searchOpen &&
    css`
      display: none;
    `}

  @media ${media.medium} {
    width: 25%;
    display: flex;
  }
`

const HeaderButton = styled.button`
  background-color: var(--ontario-colour-greyscale-black);
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: none;
  color: var(--ontario-colour-greyscale-white);
  cursor: pointer;

  display: flex;
  align-items: center;

  font-size: 1.125rem;
  font-weight: 600;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  height: 48px;
  line-height: 1.5555555556;
  text-align: center;
  text-decoration: none;

  &:focus {
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:hover,
  &:focus,
  &:visited {
    color: var(--ontario-colour-greyscale-white);
  }
`

export const SearchTogglerButton = styled(HeaderButton)`
  background-color: var(--ontario-colour-greyscale-black);
  color: var(--ontario-colour-greyscale-white);
  padding: var(--ontario-spacing-2) var(--ontario-spacing-3);
  margin-left: var(--ontario-spacing-4);

  svg {
    width: 2rem;
    height: 2rem;
    fill: var(--ontario-colour-greyscale-white);

    @media ${media.small} {
      margin-right: 4px;
    }
  }

  &:hover,
  &:focus {
    background-color: var(--ontario-colour-greyscale-greyscale70);
  }

  &:active {
    background-color: var(--ontario-colour-greyscale-greyscale60);
  }

  @media ${media.medium} {
    display: none;
  }
`

export const SearchCloseButtonContainer = styled.div`
  display: none;
  justify-content: flex-end;
  padding-right: var(--ontario-spacing-0);

  ${props =>
    props.searchOpen &&
    css`
      display: flex;
    `}

  @media ${media.medium} {
    width: 25%;
    display: none;
  }

  @media ${media.small} {
    width: 25%;
  }
`

export const SearchCloseButton = styled(HeaderButton)`
  background-color: var(--ontario-colour-greyscale-black);
  color: var(--ontario-colour-greyscale-white);
  flex-direction: column-reverse;
  font-weight: 400;
  margin-right: var(--ontario-spacing-4);
  padding: 2.4px var(--ontario-spacing-1);
  position: relative;
  height: 60px;
  z-index: 10;

  span {
    position: relative;
    top: -3px;
    font-size: 1rem;
    margin-left: var(--ontario-spacing-0);

    @media screen and ${media.small} {
      margin-right: 4px;
    }

    &:hover,
    &:focus {
      outline: none;
      text-decoration: none;
    }
  }

  svg {
    top: 0;
  }

  @media ${media.small} {
    flex-direction: row;
    padding: var(--ontario-spacing-1) var(--ontario-spacing-2)
      var(--ontario-spacing-1) var(--ontario-spacing-4);
    height: 48px;

    span {
      top: 0;
    }

    svg {
      position: relative;
      width: var(--ontario-spacing-7);
      height: var(--ontario-spacing-7);
    }
  }

  &:hover,
  &:focus {
    background-color: var(--ontario-colour-greyscale-greyscale70);
  }

  &:active {
    background-color: var(--ontario-colour-greyscale-greyscale60);
  }
`

export const MenuButton = styled(HeaderButton)`
  border: 2px solid var(--ontario-colour-greyscale-white);
  margin: var(--ontario-spacing-0) var(--ontario-spacing-0)
    var(--ontario-spacing-0) var(--ontario-spacing-4);
  padding: 0.375rem var(--ontario-spacing-4);

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 6px;

    @media screen and (max-width: 20em) {
      margin: 0;
    }
  }

  span {
    @media screen and (max-width: 20em) {
      display: none;
    }
  }

  &:hover {
    border: 2px solid var(--ontario-colour-greyscale-white);
    color: var(--ontario-colour-greyscale-white);
    background-color: var(--ontario-colour-greyscale-greyscale70);
  }

  &:focus {
    background-color: var(--ontario-colour-greyscale-greyscale70);
  }

  @media screen and (max-width: 20em) {
    padding: 0.375rem var(--ontario-spacing-2);
  }
`

/*** Navigation ****/
export const NavigationContainer = styled.nav`
  position: absolute;
  width: 100%;

  @media ${media.medium} {
    position: relative;
    max-width: 72rem;
    width: auto;
    margin: 0 auto;
  }
`

export const NavigationList = styled.div`
  background: var(--ontario-colour-greyscale-white);
  position: absolute;
  width: 100%;
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out, visibility 0.1s ease;
  z-index: 4;
  visibility: hidden;
  ${props =>
    props.navOpen &&
    css`
      transform: translateY(0);
      transition: transform 0.4s ease-in-out;
      visibility: visible;
    `}

  ul {
    background: var(--ontario-colour-greyscale-white);
    border-radius: 4px;
    list-style: none;
    padding: var(--ontario-spacing-2) var(--ontario-spacing-0);
    margin: var(--ontario-spacing-0);
    border-bottom: 1px solid var(--ontario-colour-greyscale-greyscale20);

    @media ${media.medium} {
      border-bottom: none;
    }
  }

  @media ${media.medium} {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    display: ${props => (props.navOpen ? 'block' : 'none')};
    position: absolute;
    right: var(--ontario-spacing-4);
    top: calc(100% - var(--ontario-spacing-2));
    transition: none;
    min-width: 290px;
    max-width: 30%;
    z-index: 3;
  }
`

export const NavigationListItem = styled.li`
  border-top: 1px solid var(--ontario-colour-greyscale-greyscale20);
  padding: var(--ontario-spacing-0);

  &:last-of-type {
    border-bottom: 1px solid var(--ontario-colour-greyscale-greyscale20);
  }
`

export const NavigationLink = styled.a`
  color: var(--ontario-colour-greyscale-black);
  display: block;
  font-size: 1.125rem;
  font-weight: 600;
  text-decoration: none;
  padding: calc(var(--ontario-spacing-3) - (var(--ontario-spacing-1) / 3.25))
    var(--ontario-spacing-6);

  &:hover {
    text-decoration: underline;
    background-color: #e5e5e5;
    color: var(--ontario-colour-greyscale-black);
  }

  &:active {
    text-decoration: underline;
    background-color: var(--ontario-colour-greyscale-greyscale20);
    color: var(--ontario-colour-greyscale-black);
  }

  &:focus,
  &:active {
    color: var(--ontario-colour-greyscale-black);
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus) inset;
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
    text-decoration: underline;
    background-color: #e5e5e5;
  }

  &:visited {
    color: var(--ontario-colour-greyscale-black);
  }

  @media ${media.medium} {
    padding: calc(var(--ontario-spacing-3) - (var(--ontario-spacing-1) / 3.25))
      var(--ontario-spacing-5);
  }
`

export const Overlay = styled.div`
  ${props =>
    props.navOpen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      z-index: 2;
    `}

  @media ${media.medium} {
    display: none;
  }
`

export const ShowForMediumUp = styled.div`
  ${visibility.ShowForMediumUp}
`

export const ShowForSmallOnly = styled.div`
  ${visibility.HideForSmallOnly}
`

export default {
  HeaderContainer,
  StyledHeader,
  HeaderRow,
  LogoContainer,
  HeaderRightSideContainer,
  SearchTogglerButton,
  SearchCloseButtonContainer,
  SearchCloseButton,
  MenuButton,
  NavigationContainer,
  NavigationList,
  NavigationListItem,
  NavigationLink,
  Overlay,
  ShowForMediumUp,
  ShowForSmallOnly,
}
